import type { ContactFieldErrors } from '@/lib/contact';

/**
 * Shared shape for the contact form's `useFormState` reducer.
 *
 * These live outside `actions.ts` on purpose: a `'use server'` module may only
 * export async functions. Exporting the `initialContactState` object from there
 * threw "A 'use server' file can only export async functions, found object" at
 * runtime and took the /contact page down with it.
 */
export type ContactFormState = {
  status: 'idle' | 'success' | 'error';
  error?: string;
  fieldErrors?: ContactFieldErrors;
  submittedName?: string;
};

export const initialContactState: ContactFormState = { status: 'idle' };
